import Dialog from '@pelckmans/elementis/components/dialog';
import JWPlayer, { JWPlayerConfig } from '@jwplayer/jwplayer-react';
import { ComponentProps, useContext } from 'react';
import ModalContext from '../../../../../contexts/ModalContext';
import DownloadDisclaimer from '../DownloadDisclaimer';
import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import { useTranslation } from 'react-i18next';

type JWPlayerMedia = {
  playlist: string;
};

type S3HostedMedia = {
  file: string;
};

type Props = {
  id: string;
  media: JWPlayerMedia | S3HostedMedia;
  downloadUrl?: string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  audioOnly?: boolean;
};

function JWPlayerModal({ id, media, downloadUrl, headerProps, audioOnly }: Props) {
  const config: JWPlayerConfig = {
    displaydescription: false,
    displaytitle: false,
    autostart: true,
    ...(audioOnly
      ? {
          width: 'auto',
          height: 40,
        }
      : {}),
  };

  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  function handleClose() {
    closeModal(id);
  }

  return (
    <Dialog id={id} modal onClose={handleClose} aria-label={t('PAGES.TOC_LEVEL.MODALS.JWPLAYER.A11Y_LABEL')}>
      <MaterialDialogHeader
        title={headerProps.title}
        onClose={handleClose}
        downloadUrl={downloadUrl}
        tags={headerProps.tags}
        titleTooltip={headerProps.titleTooltip}
      />
      <Dialog.Body
        alertGroupProps={
          !downloadUrl ? { 'aria-label': undefined, role: undefined, children: <DownloadDisclaimer /> } : undefined
        }
      >
        <JWPlayer library="https://content.jwplatform.com/libraries/zyraJCSg.js" config={config} {...media} />
      </Dialog.Body>
    </Dialog>
  );
}

export default JWPlayerModal;
